<div class="flex flex-col justify-center items-center">
  <h2 class="title-text my-8">Barcode Scanner</h2>
  <div class="qr-code-container">
    <input
      #scanInput
      type="text"
      [(ngModel)]="scanValue"
      (keydown.enter)="scanSuccessHandler(scanValue); scanValue=''"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
    />
  </div>
</div>
